import React from "react";
import logo from "../assets/logo/Transprant.png";

export default function Home() {
  return (
    <main className="page">
      {/* HERO SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #0db760 0%, #0a0a0a 100%)",
          color: "#ffffff",
          padding: "40px 20px",
          borderRadius: 16,
          marginBottom: 32,
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="7BOX Logo"
          style={{
            maxWidth: "200px",
            width: "100%",
            height: "auto",
            marginBottom: 24,
            display: "block",
            margin: "0 auto 24px",
          }}
        />
        <h1 style={{ fontSize: 28, marginBottom: 16, lineHeight: 1.3 }}>
          Fresh Groceries Delivered <br />
          <span style={{ color: "#ffc107" }}>to Your Doorstep</span>
        </h1>

        <p style={{ fontSize: 16, lineHeight: 1.6, opacity: 0.95, maxWidth: 500, margin: "0 auto 24px" }}>
          7BOX connects you with local grocery stores. Order fresh vegetables, 
          fruits, and daily essentials with fast, reliable delivery.
        </p>

        {/* DOWNLOAD BUTTONS */}
        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <a
            href="#"
            style={{
              background: "#ffffff",
              color: "#0a0a0a",
              padding: "14px 24px",
              borderRadius: 10,
              textAlign: "center",
              fontWeight: "bold",
              textDecoration: "none",
              fontSize: 15,
            }}
          >
            📱 Download for Android
          </a>

          <a
            href="#"
            style={{
              background: "#ffffff",
              color: "#0a0a0a",
              padding: "14px 24px",
              borderRadius: 10,
              textAlign: "center",
              fontWeight: "bold",
              textDecoration: "none",
              fontSize: 15,
            }}
          >
            🍎 Download for iOS
          </a>
        </div>
      </section>

      {/* WHAT WE OFFER */}
      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 24, marginBottom: 20, textAlign: "center" }}>
          Shop Fresh & Local
        </h2>
        
        <div className="grid-3">
          {/* VEGETABLES SECTION */}
          <div
            style={{
              background: "#ffffff",
              padding: 24,
              borderRadius: 16,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              borderLeft: "4px solid #0db760",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 12 }}>🥬</div>
            <h3 style={{ marginTop: 0, marginBottom: 12, fontSize: 20 }}>
              Fresh Vegetables
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
              Get the freshest vegetables delivered from local farms and stores. 
              Choose from a wide variety including:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Leafy greens (spinach, lettuce, kale)</li>
              <li>Root vegetables (carrots, potatoes, onions)</li>
              <li>Tomatoes, peppers, and cucumbers</li>
              <li>Seasonal vegetables at best prices</li>
            </ul>
          </div>

          {/* FRUITS SECTION */}
          <div
            style={{
              background: "#ffffff",
              padding: 24,
              borderRadius: 16,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              borderLeft: "4px solid #ffc107",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 12 }}>🍎</div>
            <h3 style={{ marginTop: 0, marginBottom: 12, fontSize: 20 }}>
              Fresh Fruits
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
              Hand-picked fruits delivered fresh to your home. Browse our selection of:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Seasonal fruits (mangoes, apples, oranges)</li>
              <li>Berries and tropical fruits</li>
              <li>Citrus fruits and melons</li>
              <li>Organic options available</li>
            </ul>
          </div>

          {/* GROCERIES SECTION */}
          <div
            style={{
              background: "#ffffff",
              padding: 24,
              borderRadius: 16,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              borderLeft: "4px solid #0db760",
            }}
          >
            <div style={{ fontSize: 32, marginBottom: 12 }}>🛒</div>
            <h3 style={{ marginTop: 0, marginBottom: 12, fontSize: 20 }}>
              Daily Groceries & Essentials
            </h3>
            <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
              Complete your shopping with all daily essentials from nearby stores:
            </p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>Dairy products (milk, cheese, yogurt)</li>
              <li>Pantry staples (rice, flour, oil, spices)</li>
              <li>Beverages and snacks</li>
              <li>Personal care and household items</li>
            </ul>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 24, marginBottom: 20, textAlign: "center" }}>
          How 7BOX Works
        </h2>
        
        <div className="grid-3">
          <div
            style={{
              background: "#ffffff",
              padding: 20,
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ fontSize: 24, marginBottom: 8 }}>1️⃣</div>
            <h3 style={{ marginTop: 0, marginBottom: 8, fontSize: 18 }}>
              Browse & Select
            </h3>
            <p style={{ margin: 0, lineHeight: 1.6 }}>
              Browse fresh vegetables, fruits, and groceries from nearby stores. 
              See prices, availability, and store ratings.
            </p>
          </div>

          <div
            style={{
              background: "#ffffff",
              padding: 20,
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ fontSize: 24, marginBottom: 8 }}>2️⃣</div>
            <h3 style={{ marginTop: 0, marginBottom: 8, fontSize: 18 }}>
              Place Your Order
            </h3>
            <p style={{ margin: 0, lineHeight: 1.6 }}>
              Add items to your cart and checkout securely. Choose your preferred 
              delivery time and payment method.
            </p>
          </div>

          <div
            style={{
              background: "#ffffff",
              padding: 20,
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            <div style={{ fontSize: 24, marginBottom: 8 }}>3️⃣</div>
            <h3 style={{ marginTop: 0, marginBottom: 8, fontSize: 18 }}>
              Fast Delivery
            </h3>
            <p style={{ margin: 0, lineHeight: 1.6 }}>
              Get your fresh groceries delivered to your doorstep. Track your order 
              in real-time and receive updates.
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE 7BOX */}
      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 24, marginBottom: 20, textAlign: "center" }}>
          Why Choose 7BOX?
        </h2>
        
        <div className="grid-2">
          <div
            style={{
              background: "#f7fdf9",
              padding: 16,
              borderRadius: 12,
              border: "1px solid #e0e0e0",
            }}
          >
            <strong style={{ fontSize: 16 }}>🥬 Fresh & Quality</strong>
            <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.6 }}>
              We partner with trusted local stores to ensure you get the freshest 
              vegetables, fruits, and groceries.
            </p>
          </div>

          <div
            style={{
              background: "#f7fdf9",
              padding: 16,
              borderRadius: 12,
              border: "1px solid #e0e0e0",
            }}
          >
            <strong style={{ fontSize: 16 }}>🚚 Fast Delivery</strong>
            <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.6 }}>
              Quick delivery from nearby stores. Get your groceries when you need them, 
              often within hours.
            </p>
          </div>

          <div
            style={{
              background: "#f7fdf9",
              padding: 16,
              borderRadius: 12,
              border: "1px solid #e0e0e0",
            }}
          >
            <strong style={{ fontSize: 16 }}>💰 Best Prices</strong>
            <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.6 }}>
              Compare prices from multiple local stores and get the best deals on 
              vegetables, fruits, and groceries.
            </p>
          </div>

          <div
            style={{
              background: "#f7fdf9",
              padding: 16,
              borderRadius: 12,
              border: "1px solid #e0e0e0",
            }}
          >
            <strong style={{ fontSize: 16 }}>🔐 Secure & Safe</strong>
            <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.6 }}>
              Secure payment options and contactless delivery. Your safety and privacy 
              are our priority.
            </p>
          </div>

          <div
            style={{
              background: "#f7fdf9",
              padding: 16,
              borderRadius: 12,
              border: "1px solid #e0e0e0",
            }}
          >
            <strong style={{ fontSize: 16 }}>📍 Support Local Stores</strong>
            <p style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.6 }}>
              By shopping with 7BOX, you're supporting local grocery stores and 
              helping your community thrive.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section>
        <div className="cta">
          Start Shopping Fresh Groceries Today
        </div>

        <p
          style={{
            textAlign: "center",
            marginTop: 20,
            fontSize: 14,
            color: "#666",
            lineHeight: 1.6,
          }}
        >
          Download the 7BOX app and get fresh vegetables, fruits, and groceries 
          delivered to your doorstep.
        </p>

        <p
          style={{
            textAlign: "center",
            marginTop: 14,
            fontSize: 13,
            color: "#777",
          }}
        >
          © {new Date().getFullYear()} 7BOX. All rights reserved.
        </p>
      </section>
    </main>
  );
}
